import { Directive, HostListener, Input, OnInit } from '@angular/core';
import { StepperSelectionEvent } from '@angular/cdk/stepper';
import { MatStepper } from '@angular/material/stepper';

@Directive({
  selector: '[MatScrollDirective]',
  standalone: true
})
export class MatVerticalStepperScrollerDirective {

  @Input() stepper!: MatStepper;

  constructor() { }

  @HostListener('selectionChange', ['$event'])
  selectionChanged(selection: StepperSelectionEvent) {
    const stepId = this.stepper._getStepLabelId(selection.selectedIndex - 1);
    const stepElement = document.getElementById(stepId);
    if (stepElement) {
      setTimeout(() => {
        stepElement.scrollIntoView({ block: 'start', inline: 'nearest' });
      }, 1);
    }
  }
}
